import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { fetchSurveysList, fetchSurveysCompletedCounts } from "../../../../slices/surveysSlice";
import { formatTimestampToLocaleGB } from "../../../../utils/DateUtils";
import SurveysSorter from "./SurveysSorter";
import SurveysFilter from "./SurveysFilter";
import SurveysPagination from "../surveys_pagination/SurveysPagination";
import NewSurveyButton from "./NewSurveyButton";
import SurveysList from "./SurveysList";
import NewSurveyModal from "../../modals/NewSurveyModal";
import LoadingIndicator from "../../../meta/LoadingIndicator";

function SurveysTable(props) {
    useEffect(() => {
        setSurveysLoading(true);
        const { user } = props;
        props.fetchSurveysList(user.userId, (surveysSuccess) => {
            props.fetchSurveysCompletedCounts(user.userId, stopSurveysLoading, stopSurveysLoading);
        }, stopSurveysLoading);
    }, []);

    const stopSurveysLoading = () => {setSurveysLoading(false)};
    const [ state, setState ] = useState({ surveysFilterStatus : null, surveysSortField: null, selectedPage: 1 });
    const { surveysFilterStatus, surveysSortField, selectedPage } = state;
    const [ isCardViewActive, setView ] = useState(true);
    const [ showNewSurvey, setShowNewSurvey ] = useState(false);
    const [ surveysLoading, setSurveysLoading ] = useState(true);

    const noSurveysPerPage = 6; // number of surveys per page

    function filterAndSortSurveys() {
        let result = surveysFilterStatus ? surveysList.filter(survey => survey.questStatus === surveysFilterStatus) : [...surveysList];
        switch (surveysSortField) {
            case "LAST_MODIFIED":
                result = result.sort((a, b) => (b.lastModified > a.lastModified) ? 1 : -1);
                break;
            case "DATE_OF_CREATION":
                result = result.sort((a, b) => (b.dateOfCreation > a.dateOfCreation) ? 1 : -1 );
                break;
            case "RESPONDENTS":
                result = result.sort( (a, b) => {
                    let aResp = surveysCompletedCountMap[a.questId] ?? 0;
                    let bResp = surveysCompletedCountMap[b.questId] ?? 0;

                    if (aResp !== bResp)
                        return (bResp > aResp) ? 1 : -1;
                    else
                        return (b.lastModified > a.lastModified) ? 1 : -1;
                } );
                break;
            default:
                result = result.sort((a, b) => (b.lastModified > a.lastModified) ? 1 : -1);
                break;
        }
        return result;
    }

    function sliceAndFormatSurveys(surveys) {
        const slicedSurveysList = surveys.slice((selectedPage-1)*noSurveysPerPage, selectedPage*noSurveysPerPage);

        return slicedSurveysList.map(survey => {
            const dateOfCreation = survey.dateOfCreation == null ? "-" : formatTimestampToLocaleGB(survey.dateOfCreation);
            const lastModified = survey.lastModified == null ? "-" : formatTimestampToLocaleGB(survey.lastModified);
            return {...survey, "dateOfCreation" : dateOfCreation, "lastModified" : lastModified}
        });
    }

    function handleSort(option) {
        setState(prevState => {
            return {...prevState, ...{surveysSortField: option, selectedPage: 1}};
          });
    }

    function handleFilter(option) {
        setState(prevState => {
            return {...prevState, ...{surveysFilterStatus: option, selectedPage: 1}};
          });
    }

    function handlePage(page) {
        setState(prevState => {
            return {...prevState, selectedPage: page};
          });
    }

    function showNewSurveyModal() {
        setShowNewSurvey(true);
    }

    function hideNewSurveyModal() {
        setShowNewSurvey(false);
    }

    const { surveysList, surveysCompletedCountMap } = props;
    const filteredSurveysList = filterAndSortSurveys();
    const finalSurveyList = sliceAndFormatSurveys(filteredSurveysList);

    const lastPage = Math.ceil(filteredSurveysList.length/noSurveysPerPage);

    const boxViewActiveClassName = "surveys__menu__filters__boxes surveys__menu__filters__boxes--active";
    const boxViewInactiveClassName = "surveys__menu__filters__boxes";
    const listViewActiveClassName = "surveys__menu__filters__list surveys__menu__filters__list--active";
    const listViewInactiveClassName = "surveys__menu__filters__list";
    const currentView = isCardViewActive ? "cards" : "table";

    return (
        <div className="container">
            {surveysLoading ?
                (<LoadingIndicator/>):
                (
                    <React.Fragment>
                        <div className="surveys__menu">
                            <NewSurveyButton toggleShowModal={showNewSurveyModal}/>
                            <NewSurveyModal modalShown={showNewSurvey} closeModal={hideNewSurveyModal}/>
                            <div className="surveys__menu__filters">
                                {
                                    filteredSurveysList.length >= 2 &&
                                    <SurveysSorter sortFunction={handleSort}/>
                                }
                                {
                                    surveysList.length >= 2 &&
                                    <SurveysFilter filterFunction={handleFilter}/>
                                }
                                {
                                    filteredSurveysList.length >= 1 &&
                                    <React.Fragment>
                                        <div className={isCardViewActive ? boxViewActiveClassName : boxViewInactiveClassName} onClick={() => {!isCardViewActive && setView(!isCardViewActive)}}></div>
                                        <div className={isCardViewActive ? listViewInactiveClassName : listViewActiveClassName} onClick={() => {isCardViewActive && setView(!isCardViewActive)}}></div>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                        {
                            filteredSurveysList.length >= 1 &&
                            <SurveysList history={props.history} surveys={finalSurveyList} completedCountMap={surveysCompletedCountMap} displayType={currentView}/>
                        }
                        {
                            filteredSurveysList.length > noSurveysPerPage &&
                            <SurveysPagination currentPage={selectedPage} lastPage={lastPage} changePageFunction={handlePage}/>
                        }
                    </React.Fragment>
                )
            }
        </div>
    )
}

function mapStateToProps(state) {
    const { surveysList, surveysCompletedCountMap } = state.surveys;
    const { user } = state.user;
    return { surveysList, surveysCompletedCountMap, user };
}

const mapDispatchToProps = { fetchSurveysList, fetchSurveysCompletedCounts };

export default connect(mapStateToProps, mapDispatchToProps)(SurveysTable);